import { theme as themes } from '@fil-react-components/theme-provider';
import { includes } from 'lodash';
import { fasChannels } from '../constants/channels/channels.constants';

export const chBasedTheme = (ch: string) => {
  var maxWidth;
  maxWidth = window?.matchMedia("(min-width: 992px)").matches ? '1256px' : '1632px';
  if (includes(fasChannels, ch))
    return {
      ...themes,
      size: {
        ...themes.size,
        grid: {
          ...themes.size.grid,
          'max-width': {
            ...themes.size.grid['max-width'],
            value: maxWidth,
          },
        },
      },
    };
  return themes;
};